module.exports = __webpack_public_path__ + "img/66_8.89c053a1.png";